import BlogContent, {
  BlogContentWithSlug,
} from "@/components/Blog/BlogContent";
import slugify from "slugify";

export const addSlug = (blog: BlogContent): BlogContentWithSlug => ({
  ...blog,
  slug: blog.slug || slugify(blog.label, { lower: true, strict: true }),
});
